export const SET_PAGINATION_DATA = "SET_PAGINATION_DATA";

export const setPagination = (total, current) => ({
  type: SET_PAGINATION_DATA,
  payload: { total, current },
});
